import { render, staticRenderFns } from "./SSSalonSettingView.vue?vue&type=template&id=baa4dff4&scoped=true&"
import script from "./SSSalonSettingView.vue?vue&type=script&lang=js&"
export * from "./SSSalonSettingView.vue?vue&type=script&lang=js&"
import style0 from "./SSSalonSettingView.vue?vue&type=style&index=0&id=baa4dff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa4dff4",
  null
  
)

export default component.exports